import { render, staticRenderFns } from "./weekly-admin-assignments-modal.vue?vue&type=template&id=6360eaa6&scoped=true"
import script from "./weekly-admin-assignments-modal.vue?vue&type=script&lang=js"
export * from "./weekly-admin-assignments-modal.vue?vue&type=script&lang=js"
import style0 from "./weekly-admin-assignments-modal.vue?vue&type=style&index=0&id=6360eaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360eaa6",
  null
  
)

export default component.exports